import { render, staticRenderFns } from "./DialogReisen.vue?vue&type=template&id=6a466163"
import script from "./DialogReisen.vue?vue&type=script&lang=ts"
export * from "./DialogReisen.vue?vue&type=script&lang=ts"
import style0 from "./DialogReisen.vue?vue&type=style&index=0&id=6a466163&prod&scopes=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports